import type { Field } from '@/api/types/crm/crm.types'
import { isCrmLeadIntegrationField } from '@pages/Admin/CRM/utils/crmLeadIntegrationFields'

/** Редактируется в блоке «Основные поля» карточки лида. */
const ABOUT_TAB_EXCLUDED_UNIQUE_NAMES = new Set([
  'VK_LINK',
  'TELEGRAM_ACCOUNT',
  'MAX_ACCOUNT',
])

/** Настраиваемые поля профиля лида (не дефолтные системные). */
export const isOptionalCustomField = (field: Field) =>
  field.is_active &&
  !field.is_default &&
  !ABOUT_TAB_EXCLUDED_UNIQUE_NAMES.has(field.unique_name) &&
  !isCrmLeadIntegrationField(field)

/** Бэк иногда отдаёт тип в другом регистре. */
export const isTextareaField = (field: Field) =>
  String(field.type).toLowerCase() === 'textarea'

export const filterOptionalSmallFields = (fields: Field[]) =>
  fields.filter((f) => isOptionalCustomField(f) && !isTextareaField(f))

export const filterOptionalTextareaFields = (fields: Field[]) =>
  fields.filter((f) => isOptionalCustomField(f) && isTextareaField(f))
